import React from 'react';
import { Provider } from 'react-redux';
import { store } from '@/stores/store';

interface AppProviderProps {
  children: React.ReactNode;
}

/**
 * Main application provider that wraps all providers needed by the app.
 * Currently includes:
 * - Redux store provider
 * 
 * Future providers can be added here (e.g., Theme, Auth, etc.)
 */
export const AppProvider: React.FC<AppProviderProps> = ({ children }) => {
  return (
    <Provider store={store}>
      {children}
    </Provider>
  );
};

export default AppProvider;